import React from 'react';
import { Button } from 'reactstrap';
import i18n from '@/utils/i18n';
import { LayoutStoreInstance } from '../../../LayoutStore';
import { useUpdateInvoiceCollectionMutation } from '../../../graphql/mutations/updateInvoiceCollection.generated';

export function StoreExcludeButton({
  invoiceCollectionId,
  storeId,
  existingExcludedIds,
  onDone,
}: {
  invoiceCollectionId: string;
  storeId: string;
  existingExcludedIds: string[];
  onDone: () => void;
}) {
  const [updateInvoiceCollection, { loading }] =
    useUpdateInvoiceCollectionMutation();

  const onExclude = async () => {
    const current = Array.from(new Set(existingExcludedIds || []));
    if (current.includes(storeId)) return;
    try {
      await updateInvoiceCollection({
        variables: {
          id: invoiceCollectionId,
          payload: { excluded_store_ids: [...current, storeId] },
        },
      });
      onDone();
      LayoutStoreInstance.setSuccess(i18n.t('Common:saved'));
    } catch (err: any) {
      LayoutStoreInstance.setError(
        i18n.t('Common:error') + ': ' + (err?.message || 'unknown'),
      );
    }
  };

  return (
    <Button
      style={{ marginLeft: '10px' }}
      className="btn btn-sm btn-warning"
      onClick={onExclude}
      disabled={loading}
    >
      {i18n.t('InvoiceCollection:exclude')}
    </Button>
  );
}
